import { IDestroyOptions } from "pixi.js";
import { CommonResourcesPackage } from "../resources/CommonResourcesPackage";
import { Hand } from "./Hand";
import { IGameViewModel } from "../../game/models/IGameViewModel";
import { nameof } from "bindable-data";
import { gsap } from "gsap";

export class HandWithDelay extends Hand {
    public static readonly DEFAULT_SCALE = 0.7;
    private showAnimation = new gsap.core.Timeline();
    private hideAnimation = new gsap.core.Timeline();

    private readonly gameViewModel: IGameViewModel;

    public constructor(gameViewModel: IGameViewModel, commonResources: CommonResourcesPackage) {
        super(commonResources);
        this.showAnimation = new gsap.core.Timeline({ paused: true });
        this.hideAnimation = new gsap.core.Timeline({ paused: true });
        this.gameViewModel = gameViewModel;
        this.gameViewModel.propertyChanged.add(this.onGameViewModelPropertyChanged, this);
    }

    private async onGameViewModelPropertyChanged(model: IGameViewModel, key: string): Promise<void> {
        switch (key) {
            case nameof(model, "isIdleState"):
                model.isIdleState.value ? this.show() : this.hide();
                break;
        }
    }

    private async show(): Promise<void> {
        this.showAnimation.set(this.scale, { x: 0, y: 0 });
        this.showAnimation.to(this.scale, { x: HandWithDelay.DEFAULT_SCALE, y: HandWithDelay.DEFAULT_SCALE, onStart: () => this.visible = true, duration: 0.5, ease: "power2.out" });
        await this.showAnimation.play();
        this.showAnimation.clear();
    }

    private async hide(): Promise<void> {
        this.hideAnimation.to(this.scale, { x: 0, y: 0, duration: 0.5, onComplete: () => this.visible = false, ease: "power2.in" });
        await this.hideAnimation.play();
        this.hideAnimation.clear();
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.showAnimation?.kill();
        this.hideAnimation?.kill();
        this.gameViewModel.propertyChanged.remove(this.onGameViewModelPropertyChanged, this);
        super.destroy(options);
    }
}
